export type SilverServiceVersionStatus = "draft" | "in_validation" | "live" | "deprecated";

export type SilverServiceVersionStatusHistoryEntry = {
  status: SilverServiceVersionStatus;
  at: string;
};

export type SilverServiceVersion = {
  version: string;
  status: SilverServiceVersionStatus;
  is_default: boolean;
  route: string | null;
  status_history?: SilverServiceVersionStatusHistoryEntry[];
};

export const versionOptionLabel = (version: SilverServiceVersion): string => `${version.version} · ${version.status}${version.is_default ? " · default" : ""}`;
